import { inject, Injectable } from '@angular/core';
import { TransactionSuccessState, TransactionSuccessStore } from './transaction-success.store';
import { MarketplaceItem } from '../marketplace/models/marketplace-item.model';
import { TicketParkingItem } from '../ticket-parking/models/ticket-parking-item.model';
import { LottoItem } from '../lotto/models/lotto-item.model';

@Injectable({ providedIn: 'root' })
export class TransactionSuccessService {
  private transactionSuccessStore = inject(TransactionSuccessStore);

  setTransaction(
    item: MarketplaceItem | LottoItem | TicketParkingItem,
    quantity: number,
    totalPrice: number,
    orderId: string = ''
  ) {
    this.transactionSuccessStore.update((_: TransactionSuccessState) => ({ item, quantity, totalPrice, orderId }));
  }

  clear() {
    this.transactionSuccessStore.reset();
  }
}
